import { parsearCsv, transaccionesDeBanorte } from "./conciliacionPagos";

const leer = (archivo, comoTexto) =>
  new Promise((resolver, rechazar) => {
    const lector = new FileReader();
    lector.onload = () => resolver(lector.result);
    lector.onerror = () => rechazar(new Error("No se pudo leer el archivo."));
    if (comoTexto) lector.readAsText(archivo, "utf-8");
    else lector.readAsArrayBuffer(archivo);
  });

// Lee el reporte "Transacciones Payworks 2" de Banorte, exportado a CSV o a Excel (.xlsx), y regresa sus transacciones.
export async function leerReporteBanorte(archivo) {
  const nombre = String((archivo && archivo.name) || "").toLowerCase();

  if (nombre.endsWith(".csv")) {
    return transaccionesDeBanorte(parsearCsv(await leer(archivo, true)));
  }

  if (nombre.endsWith(".xlsx") || nombre.endsWith(".xls")) {
    // La libreria de Excel pesa mucho: se carga solo cuando hace falta.
    const XLSX = await import("xlsx");
    const libro = XLSX.read(await leer(archivo, false), { type: "array" });
    const hoja = libro.Sheets[libro.SheetNames[0]];
    // raw:false => cada celda como texto tal cual se ve (fechas y horas del banco ya vienen como texto)
    return transaccionesDeBanorte(XLSX.utils.sheet_to_json(hoja, { header: 1, raw: false, defval: "" }));
  }

  throw new Error("El archivo debe ser el reporte de Banorte en formato CSV o Excel (.xlsx).");
}
